import { reduxHelper } from 'utils/reduxHelper';

import {
    AppHeaderActions,
    AppHeaderSelectors,
} from 'reactApp/modules/AppHeaderModule/AppHeaderModule';

const actions = reduxHelper.bindActions(AppHeaderActions);
const selectors = reduxHelper.bindSelectors(AppHeaderSelectors);

export const BoundAppHeaderActions = {
    addItem: actions.addItem,
    addSubitem: actions.addSubitem,
    removeItem: actions.removeItem,
    removeSubitem: actions.removeSubitem,
    updateItem: actions.updateItem,
    updateSubitem: actions.updateSubitem,
};

export const BoundAppHeaderSelectors = {
    getItem: selectors.getItem,
    getItems: selectors.getItems,
};
